import FooterSection from './FooterSection';
import GrowingFamilySection from './GrowingFamilySection';
import LibraryWidget from './LibraryWidget';
import NewsletterSection from './NewsletterSection';
import PartnerSection from './PartnerSection';
export default class Website {
    static fromApi(response) {
        const website = new Website();
        if (response === null || response === void 0 ? void 0 : response.growing_family_section)
            website.growing_family_section = GrowingFamilySection.fromPartial(response.growing_family_section);
        if (response === null || response === void 0 ? void 0 : response.library_widget)
            website.library_widget = LibraryWidget.fromPartial(response === null || response === void 0 ? void 0 : response.library_widget);
        if (response === null || response === void 0 ? void 0 : response.newsletter_section)
            website.newsletter_section = NewsletterSection.fromPartial(response.newsletter_section);
        if (response === null || response === void 0 ? void 0 : response.partner_section)
            website.partners_section = PartnerSection.fromPartial(response.partner_section);
        if (response === null || response === void 0 ? void 0 : response.footer_section)
            website.footer_section = FooterSection.fromPartial(response.footer_section);
        return website;
    }
}
